module.exports = __webpack_public_path__ + "img/UserWalletTransactions.251895b4.svg";